import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import type { InboxMessage } from "./use-inbox-conversation";

export function useRetryInboxMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ brandId, messageId }: { brandId: string; messageId: string; conversationId: string }) =>
      apiFetch<InboxMessage>(`/brands/${brandId}/inbox/messages/${messageId}/retry`, {
        method: "POST",
        body: JSON.stringify({}),
      }),
    onSuccess: (serverRow, vars) => {
      qc.setQueryData(
        ["inbox-conversation", vars.brandId, vars.conversationId],
        (prev: any) => {
          if (!prev) return prev;
          const messages = (prev.messages ?? []).map((m: InboxMessage) =>
            m.id === serverRow.id ? serverRow : m,
          );
          return { ...prev, messages };
        },
      );
    },
  });
}
